import React,{Component} from 'react';
import WorkTagView from './WorkTagView';
import Notification from './Notification';
import UserListItem from './UserListItem';
class UserListView extends Component{

  constructor(props){
    super(props);
  }

  render(){
    const users = this.props.users != undefined ? this.props.users.map( (i,index) => {
      return <UserListItem user={i}  key={index} sendTestMessageToUser={this.props.sendTestMessageToUser}/>
    }): null;
      return (
        <>
        <ol className="userList workerList">
        {users}
        </ol>
        <button className="btnThirdButton" onClick={this.props.changeToAddUserView}  >
        Lisää käyttäjä
    </button>
    <button className="btnClose" onClick={this.props.changeToEmployeesView}  >
        Palaa
    </button>
    </>
    )


  }
}
export default UserListView;
